(function () {
    'use strict';
    
    angular
    .module('szallodak-cancellation-policy', ['ui.checkbox']);
})();
